import { render, staticRenderFns } from "./GrantUserForOwnership.vue?vue&type=template&id=ad31b2e0&scoped=true"
import script from "./GrantUserForOwnership.vue?vue&type=script&lang=js"
export * from "./GrantUserForOwnership.vue?vue&type=script&lang=js"
import style0 from "./GrantUserForOwnership.vue?vue&type=style&index=0&id=ad31b2e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad31b2e0",
  null
  
)

export default component.exports